/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { memo } from 'react';
import { Trans } from 'react-i18next';

import { Box, Collapse, FormHelperText } from '@mui/material';

import { Namespaces } from '../../i18n';
import { LoginErrorKey } from '../../types/login/LoginError';
import { useErrorMessageWithIconStyles } from '../ErrorMessageWithIcon/ErrorMessageWithIcon.styles';
import { ErrorIcon } from '../LoginError/components/ErrorIcon';

interface CredentialsErrorProps {
  show: boolean;
  errorKey: LoginErrorKey;
  userEmail?: string;
}

export const CredentialsError = memo<CredentialsErrorProps>(({ show, errorKey }) => {
  const classes = useErrorMessageWithIconStyles();

  return (
    <Collapse in={show} timeout={300}>
      <FormHelperText
        sx={{
          padding: '7px 50px 7px 0 !important',
          margin: 0,
          fontSize: '12px',
          lineHeight: '16px',
          minWidth: 0,
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            padding: 0,
          }}
        >
          <ErrorIcon errorKey={errorKey} />
          <span className={classes.error} style={{ fontSize: '13px' }}>
            <Trans i18nKey={`page.login.error.${errorKey}`} ns={Namespaces.Login} />
          </span>
        </Box>
      </FormHelperText>
    </Collapse>
  );
});
